// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"dcf8c19f1a70710501fc","883":"9f2270d1ec7dc5fdb316"}[chunkId] + ".js";
};